export default __webpack_public_path__ + "static/icon-8-4-57fb2045bb83e7bbe49a32976f5f8da4.png";